import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import AvatarFace from './AvatarFace';
import styles from './ConsequenceReveal.module.css';

const toneMap = {
  success: '#2a9d8f',
  warning: '#f4a261',
  danger: '#e63946',
  neutral: '#264653'
};

const expressionMap = {
  success: 'happy',
  warning: 'concerned',
  danger: 'confused',
  neutral: 'neutral'
};

const ConsequenceReveal = ({
  visible,
  tone = 'neutral',
  icon,
  message = 'Choice recorded.',
  expression,
  onDone,
  duration = 2000
}) => {
  const color = toneMap[tone] || toneMap.neutral;
  const faceExpression = expression || expressionMap[tone] || 'neutral';

  useEffect(() => {
    if (!visible) return undefined;
    const timer = window.setTimeout(() => {
      if (onDone) onDone();
    }, duration);
    return () => window.clearTimeout(timer);
  }, [duration, onDone, visible]);

  return (
    <AnimatePresence>
      {visible ? (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.card}
            style={{ borderTopColor: color }}
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -20, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 130, damping: 20 }}
          >
            <div className={styles.faceWrap}>
              <AvatarFace expression={faceExpression} size={56} accent={color} />
            </div>
            <div className={styles.content}>
              <span className={styles.icon} style={{ color }}>
                {icon || (tone === 'success' ? '✓' : tone === 'danger' ? '✗' : '→')}
              </span>
              <span className={styles.message}>{message}</span>
            </div>
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default ConsequenceReveal;
